import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative h-[724px] overflow-hidden bg-[#f7f6fb] lg:h-[720px]',
    visual: 'h-full',
    image: 'sm:h-full sm:w-full sm:object-cover',
    product:
      'absolute right-0 bottom-8.5 left-0 pr-3 pl-5 lg:top-32 lg:right-auto lg:bottom-auto lg:left-[calc(50%+167px)] lg:max-w-[403px] lg:px-0',
    title:
      'mb-2 text-[32px] leading-[1.2] font-light tracking-[0.1em] uppercase',
    text: 'mb-4 text-base leading-[1.2] font-light tracking-[0.06em] lg:mb-11 lg:text-[18px]',
    content: 'max-w-[403px]',
    priceWrapper: 'flex flex-col gap-4',
    price: 'flex items-baseline gap-2 font-(family-name:--font-source-serif-4)',
    priceText: 'text-3xl leading-[1.3] text-nowrap lg:text-[34px]',
    priceOld:
      'relative text-lg leading-[1.3] font-light text-nowrap text-[#898989] lg:text-2xl',
    buttons: 'flex gap-3',
    button:
      'flex-center h-12 cursor-pointer border border-[#24233D] bg-[#24233D] px-6 text-sm leading-[1.3] font-semibold tracking-[0.04em] text-white uppercase transition-colors duration-300 hover:bg-transparent hover:text-[#24233D] max-md:w-full md:min-w-[140px]',
    buttonSecondary:
      'flex-center h-12 cursor-pointer border border-[#24233D] bg-transparent px-6 text-sm leading-[1.3] font-semibold tracking-[0.04em] text-[#24233D] uppercase transition-colors duration-300 hover:bg-[#24233D] hover:text-white max-md:w-full md:min-w-[140px]',

    info: 'absolute top-7 right-4 z-10 flex max-w-[280px] items-center gap-3 lg:top-[94px] lg:right-auto lg:left-[calc(50%-386px)] lg:max-w-[423px] lg:gap-4',
    infoContent: 'min-w-0 lg:mt-3',
    infoText:
      'mb-0.5 text-[12px] leading-[1.3] font-bold tracking-[0.2em] text-[#24233D] uppercase lg:mb-2 lg:text-[14px]',
    infoNumber:
      'shrink-0 [font-family:var(--font-source-serif-4)] text-[72px] leading-[1] font-light lg:text-[100px]',
    infoSmall: 'text-[45px] lg:text-[62px]',
    infoDescription: 'text-[14px] leading-[1.3] font-light lg:text-[18px]',

    giftBadge:
      'absolute top-[128px] right-[20px] z-10 text-[12px] leading-[1.3] font-semibold tracking-[0.2em] text-[#24233D] uppercase lg:hidden',
    gift: 'absolute bottom-15 left-[calc(50%-30px)] z-10 hidden max-w-[320px] lg:block',
    giftLabel:
      'mb-2 text-[12px] leading-[1.3] font-bold tracking-[0.2em] text-[#24233D] uppercase lg:text-[14px]',
    giftText: 'text-[13px] leading-[1.3] font-light lg:text-[18px]'
  }
});
